angular.module('unergie.main')
.controller('ogcContactListsCtrl', ($scope, $state, ApiAdmin, BoFeaturesService, AlertManager, ModalService, TableGeneratorService, DataAccess, OGC, ErrorCatcher) => {
    $scope.canRefreshMatViews = BoFeaturesService.isFeatureOn('canRefreshMatViews')

    const cronInstance = new Cron({
        timezone: 'Europe/Paris',
    })

    $scope.contactLists = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'external_id': { label: 'Id sendinblue', mode: 'search_operator', mandatory: true },
            'refSendinblueList.functional_id': { label: 'Abonnement', mode: 'search_wildcard' },
            'id_ref_sendinblue_list': { label: 'Id Abonnement', mode: 'hidden' },
            'name': { label: 'Libellé', mode: 'search_wildcard', mandatory: true },
            'data_view': { label: 'Segment', mode: 'search_wildcard', mandatory: true },
            'creation_ts': { label: 'Date de création', mode: 'search_date', mandatory: true },
            'last_synch': { label: 'Dernière mise à jour', mode: 'search_date', mandatory: true },
            'active_synch': { label: 'Récurrente', mode: 'hidden' },
            'synchronize_cron': { label: 'Récurrence', mode: 'search_wildcard', mandatory: true },
            'id_folder': { label: 'Id dossier', mode: 'hidden' },
            'attributes': { label: 'Attributs', mode: 'hidden' },
            'filters': { label: 'Filtres', mode: 'hidden' },
            'modification_ts': { label: 'Date de modification', mode: 'hidden' },
        },
    }

    $scope.dataViewTranslator = {
        urg_mvw_ogc_client: 'Clients',
        urg_mvw_ogc_contract: 'Contracts',
        urg_mvw_ogc_prospect: 'Prospects',
        urg_mvw_ogc_b2g: 'B2G',
        urg_mvw_ogc_b2bg_user: 'Utilisateurs B2BG',
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.contactLists, 'ogc-contact-lists', null, null, { orderBy: 'name' })

    $scope.openContactListModal = (cl, e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        ModalService.openModal({
            type: 'ogcContactListsModal',
            size: 'xlg',
            backdrop: 'static',
        }, { contactList: cl && _.omit(cl, ['expanded', 'nbContacts', 'synchronizing', 'last_synch', 'details', 'functional_id']) }, $scope.refresh)
    }

    $scope.deleteList = (cl) => {
        return OGC.deleteContactList({ id: cl.id }).$promise
        .then(() => {
            AlertManager.success(`Liste supprimée`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.duplicateList = (cl) => {
        const newOne = _.cloneDeep(cl)
        newOne.name = `${newOne.name} duplicata`
        return OGC.addContactList(_.omit(newOne, ['id', 'external_id', 'expanded', 'nbContacts', 'last_synch', 'synchronizing', 'details', 'functional_id', 'modification_ts'])).$promise
        .then(() => {
            AlertManager.success(`Liste dupliquée : ${newOne.name}`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }


    $scope.needsSynch = (cl) => {
        return cl.last_synch && moment(cl.modification_ts).isAfter(moment(cl.last_synch))
    }

    $scope.synchronizeList = (cl) => {
        cl.synchronizing = true
        return OGC.synchronizeList({ id: cl.id }, {}).$promise.then(() => {
            AlertManager.success(`Liste synchronizée`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            cl.synchronizing = false
        })
    }

    const getContactListDetails = (cl) => {
        return ApiAdmin.getContactListDetails({ id: cl.external_id }).$promise
        .then((result) => {
            cl.details = result
        })
        .catch(ErrorCatcher)
    }

    $scope.toggleExpand = (cl) => {
        cl.expanded = !cl.expanded
        if (cl && cl.nbContacts == null) {
            getContactListDetails(cl)
            return OGC.countContactList({ id: cl.id }).$promise.then((countResult) => {
                cl.nbContacts = countResult.count
            })
        }
    }

    $scope.deleteFields = {
        label: {
            label: (cl) => cl.external_id && `<span class="red"><span class="fa fa-warning"/>&nbsp;Attention cela supprimera aussi la liste dans l'OGC (mais pas ses contacts)</span>`,
            type: 'label',
        },
    }

    $scope.refreshMatViewsTemplate = {}

    $scope.refreshMatViewsFields = {
        matView: {
            label: 'Vue matérialisée',
            type: 'select',
            enum: [
                { value: 'urg_mvw_ogc_prospect', label: 'Prospects' },
                { value: 'urg_mvw_ogc_client', label: 'Clients' },
                { value: 'urg_mvw_ogc_contract', label: 'Contracts' },
                { value: 'urg_mvw_ogc_b2g', label: 'B2G' },
                { value: 'urg_mvw_ogc_b2bg_user', label: 'Utilisateurs B2BG' },
            ],
        },
    }

    $scope.refreshMatView = () => {
        $scope.refreshingMatView = true
        return DataAccess.refreshMatView({ matView: $scope.refreshMatViewsTemplate.matView }, {}).$promise.then(() => {
            AlertManager.success(`Vue rafraîchie`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingMatView = false
        })
    }

    $scope.checkSync = () => {
        $scope.checkingSync = true
        return OGC.checkSync({}).$promise.then((result) => {
            AlertManager.success(`Synchro vérifiées : `, 10000, result)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.checkingSync = false
        })
    }

    $scope.nextTicks = (cl) => {
        let html = '<strong>5 prochaines mises à jour :</strong><ul>'
        cronInstance.fromString(cl.synchronize_cron)
        const schedule = cronInstance.schedule()
        for (let i = 0; i < 5; i++) {
            html += `<li>${schedule.next().format('DD/MM/YYYY HH:mm')}</li>`
        }
        html += '</ul>'
        return { $promise: Promise.resolve([html]) }
    }

    $scope.refresh()
})
